module.exports = __webpack_public_path__ + "img/logoCordobaTurismo.fd67aae0.svg";